export default __webpack_public_path__ + "media/images/icons/door-c5a281297f50b2ddb947f6a5ad8ffbc3.svg";